<template>
  <main class="main" id="main">
    <franchiseNav></franchiseNav>
    <div class="top_line">
      <div class="container">
        <h1>СОЗДАТЬ СВОЙ SaaS АГРЕГАТОР И НЕ ЗАВИСЕТЬ ОТ ФРАНШИЗЫ</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <!--h2 style="margin-top:2%;">Почему люди покупают <router-link to="/franchise">франшизу Хочу-Поесть</router-link>?</h2-->

            <p style="margin-top:2%;">Ваш собственный агрегатор доставки еды без взноса, роялти и зависимости.</p>
            <p><br />Для Вас - SaaS решение – настраиваем и передаем Вам работающий бизнес.</p>

            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h2>ЧТО ТАКОЕ SaaS</h2>
            <p><br />Мы создадим для Вас за 5 дней Ваш собственный агрегатор food-delivery.</p>
            <p><br /> &mdash; Это передача Вам полнофункционального десктопного ресурса с мобильными приложениями для Android и IOS.</p>
            <p><br /> &mdash; Это полностью Ваш бизнес который мы настраиваем и передаем Вам за 5 дней.</p>
            <p><br /> &mdash; Вы можете делать со своим агрегатором что угодно: запуститься в каком-то городе или стране, продавать свои франшизы, а можете вовсе не работать – Вы никому и ничем не обязаны.</p>
            <p>&nbsp;</p>
            <p><br />По сути, SaaS представляет собой лицензию программного обеспечения (решения). Вы платите за покупку лицензии (интеграцию ИТ).</p>
            <p><br />Стоимость Вашего собственного агрегатора для Вас – всего от 1000 долларов. И агрегатор полностью Ваш. Придумывайте название, давайте логотип, домен, это «натягивается» на Ваш дизайн и все работает. Срок интеграции – до 5 дней.</p>
            <p>&nbsp;</p>
            <p><br /><b>А что если делать самостоятельно? Давайте посчитаем</b></p>
            <p><br />Даже имея полное техническое задание более простого агрегатора доставки еды стоимость самостоятельной разработки составляет не менее 35000 долларов.</p>
            <p><br />Срок разработки десктоп и приложений – 7-14 месяцев.</p>
            <p><br />Стоимость обслуживания и технической поддержки чернового ресурса– от 1200 долларов в месяц.</p>
            <p><br />Преимущество очевидно даже не вникая в тонкую математику. Вы получаете от нас все готовое!</p>
            <p>&nbsp;</p>
            <p><br />По вопросам приобретения пишите <b>sev@hochu-poest.com</b> или <b>ICQ 333494862</b></p>
            <p>&nbsp;</p>
            <center>
              <p style="font-size: 16pt;">
                <br />WHEN-HUNGRY - МОНОПОЛИСТ НА РЫНКЕ SAAS FOOD DELIVERY<br /><br />
                Партнеры ценят нас за то, что мы являемся адекватным игроком и играем по рыночным правилам.<br /><br />
                Соблюдение рыночных правил в части стоимости решений и лицензий, а также<br /><br />
                принципов взаимодействия является приоритетной ценностью нашей компании.
              </p>
            </center>
            <p>&nbsp;</p>
            <!--p>
              <br /><b>
                Ознакомьтесь с другими нашими решениями в других областях!<br />
                Создайте свой интернет-бизнес в аренде строительной техники, ремонте автомобилей, доставке еды и заказе Дедов Морозов.
              </b>
            </p>
            <p>&nbsp;</p>
            <center>
              <p>
                <a href="https://place-tech.com/saas" target="_blank"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/pt_logo_com.png" width="240" /></a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a href="https://xn----8sbecarw9btief.xn--p1ai/saas-rus" target="_blank"><img src="https://xn----8sbecarw9btief.xn--p1ai/static/img/general/logo.png" width="240" /></a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a href="https://dedushka-moroz.com/saas" target="_blank"><img src="https://dedushka-moroz.com/static/img/santa-claus-main-logotype.png" width="240" /></a>
              </p>
            </center>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p-->
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import franchiseNav from '@/components/franchiseNav'
export default {
  name: 'saas',
  components: {franchiseNav}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/saas.vue